import React from 'react';

import { RequiredTag } from '@components/Forms/RequiredTag';
import { makeMuiStyles, useCommonStyles } from '@styles';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    height: '48px',
    border: `1px solid ${Color(theme.palette.primary.main).alpha(0.2).toString()}`,
    backgroundColor: theme.palette.background.paper,
    ...common.flexInline,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      alignItems: 'stretch',
    },
  },
  idBox: {
    width: '48px',
    backgroundColor: theme.palette.primary.main,
    ...common.flexCenter,
    ...common.bigText,
    ...common.fontWeight500,
    color: theme.palette.primary.contrastText,
  },
  idBoxInactive: {
    width: '48px',
    backgroundColor: Color(theme.palette.primary.main).alpha(0.5).string(),
    ...common.flexCenter,
    ...common.bigText,
    ...common.fontWeight500,
    color: theme.palette.primary.contrastText,
  },
  titleContainer: {
    ...common.flexInline,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumn,
      padding: '11px 0',
    },
  },
  titleBox: {
    height: '100%',
    flex: 1,
    padding: '0 12px 0 12px',
    ...common.flexInline,
    alignItems: 'center',
    ...common.bigText,
    ...common.fontWeight500,
    color: theme.palette.text.primary,
    whiteSpace: 'pre',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
    },
  },
  subtitleBox: {
    height: '100%',
    flex: 5,
    padding: '0 12px 0 12px',
    ...common.flexInline,
    alignItems: 'center',
    ...common.exSmallerText,
    ...common.fontWeight500,
    color: theme.palette.grey[500],
  },
  requiredTag: {
    marginLeft: 10,
    position: 'relative',
    top: 1,
  },
}));

export interface FormSectionTitleProps {
  id?: number;
  title: React.ReactNode;
  subtitle?: string;
  active?: boolean;
  required?: boolean;
}

export const FormStepSectionTitle: React.FC<FormSectionTitleProps> = (props) => {
  const { id, title, subtitle, active = true, required } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.container}>
      {id && <div className={active ? classes.idBox : classes.idBoxInactive}>{id}</div>}
      <div className={classes.titleContainer}>
        <div className={classes.titleBox}>
          {title}
          {required && <RequiredTag className={classes.requiredTag} />}
        </div>
        {subtitle && <div className={classes.subtitleBox}>{subtitle}</div>}
      </div>
    </div>
  );
};
